import React from "react";
import TableSortLabel from "@mui/material/TableSortLabel";
import { styled } from "@mui/material/styles";

const CustomTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
  "&.Mui-active, &:focus, &:hover": {
    color: "white", textDecoration: "underline",
  },
}));

export default function StyledTableSortLabel(props) {
  return (<CustomTableSortLabel {...props} sx={{
    "& .MuiTableSortLabel-icon": {
      color: "white !important",
    },
  }}/>);
}